fragment TwoPortraitImagesFragment on twoPortraitImages_Entry {
  typeHandle
  images {
    url
    title
  }
}
